<eds-dropdown
  style="min-width: 250px"
  edsSpacing="md"
  [items]="exchangeItems"
  [label]="'products.list-all-exchanges' | translate"
  (dropdownChange)="parentComponent.filterExchange($event)"
></eds-dropdown>
